import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectPracticumState = (state: RootState) => state.practicumState;

export const selectPracticumOValue = createSelector(
  selectPracticumState,
  (state) => {
    return state.practicumValue;
  }
);

export const selectPracticumLoading = createSelector(
  selectPracticumState,
  (state) => {
    return state.isPracticumLoading;
  }
);
